module.exports = __webpack_public_path__ + "static/img/8619_phase_function_Paper_Points.cdee9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8619_phase_function_Paper_Points.png
// module id = ofI7
// module chunks = 0